import { render, staticRenderFns } from "./PricelistProduct.vue?vue&type=template&id=185ae446&"
import script from "./PricelistProduct.vue?vue&type=script&lang=js&"
export * from "./PricelistProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports